<script lang="ts">
  import { appState } from '../state.svelte';

  let { onClick }: { onClick: () => void } = $props();
</script>

<button
  type="button"
  class="tashimoto-support-fixed tashimoto-support-bottom-6 tashimoto-support-right-6 tashimoto-support-w-14 tashimoto-support-h-14 tashimoto-support-rounded-full tashimoto-support-bg-blue-500 hover:tashimoto-support-bg-blue-600 tashimoto-support-shadow-lg tashimoto-support-text-white tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-center tashimoto-support-transition-colors"
  style="z-index: {appState.zIndex};"
  data-testid="support-bubble"
  aria-label="Open support chat"
  onclick={onClick}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path
      d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z"
    ></path>
  </svg>
  {#if appState.unreadCount > 0}
    <span
      class="tashimoto-support-absolute tashimoto-support--top-1 tashimoto-support--right-1 tashimoto-support-bg-red-500 tashimoto-support-text-white tashimoto-support-text-xs tashimoto-support-font-bold tashimoto-support-rounded-full tashimoto-support-min-w-[20px] tashimoto-support-h-5 tashimoto-support-px-1 tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-center"
      data-testid="unread-badge"
    >
      {appState.unreadCount > 99 ? '99+' : appState.unreadCount}
    </span>
  {/if}
</button>
